import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useAtomValue } from "jotai/index";
import React, { useState } from "react";
import { useNavigate } from "react-router";

import { login } from "../auth";
import { userAtom } from "../store";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const user = useAtomValue(userAtom);

  const navigate = useNavigate();

  if (user !== null) {
    navigate("/");
  }

  const handleLogin = async () => {
    try {
      await login(email, password);
      navigate("/");
    } catch (e) {
      if (e instanceof Error) {
        alert(e.message);
      }
    }
  };

  return (
    <Stack spacing={2}>
      <TextField
        label="Email"
        variant="outlined"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setEmail(e.target.value);
        }}
      />
      <TextField
        label="Password"
        variant="outlined"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setPassword(e.target.value);
        }}
      />
      <Button onClick={handleLogin}>Login</Button>
    </Stack>
  );
};
